__turbopack_context__.v({
  "mobileView": "MobileView-module__jZGnJW__mobileView",
});
